var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.title))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "translation_wrap" }, [
              _c("dl", { staticClass: "dl_select" }, [
                _c("dd", { attrs: { "data-input-type": "select" } }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.transParam.source.language,
                          expression: "transParam.source.language"
                        }
                      ],
                      staticClass: "slt_none w100p",
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.transParam.source,
                              "language",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.changeSourceLang
                        ]
                      }
                    },
                    _vm._l(_vm.transParam.source.langList, function(
                      sourceCode
                    ) {
                      return _c(
                        "option",
                        {
                          key: sourceCode.codeId,
                          domProps: { value: sourceCode.code }
                        },
                        [_vm._v(_vm._s(sourceCode.text))]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c(
                  "dd",
                  { staticClass: "icon", on: { click: _vm.setLanguageChange } },
                  [_vm._m(0)]
                ),
                _vm._v(" "),
                _c("dd", { attrs: { "data-input-type": "select" } }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.transParam.target.language,
                          expression: "transParam.target.language"
                        }
                      ],
                      staticClass: "slt_none w100p",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.transParam.target,
                            "language",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    _vm._l(_vm.transParam.target.langList, function(
                      targetCode
                    ) {
                      return _c(
                        "option",
                        {
                          key: targetCode.codeId,
                          domProps: { value: targetCode.code }
                        },
                        [_vm._v(_vm._s(targetCode.text))]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "btn" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn_blue",
                      attrs: { href: "javascript:" },
                      on: { click: _vm.getTranslation }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.TRANSLATE")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn_white",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.copyText($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.COPY")))]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("dl", { staticClass: "trans_write_wrap" }, [
              _c("dd", { attrs: { "data-input-type": "textarea" } }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.transParam.source.text,
                      expression: "transParam.source.text"
                    }
                  ],
                  staticClass: "textarea_ty w100p scroll",
                  attrs: { rows: "15", maxlength: "5000", placeholder: "" },
                  domProps: { value: _vm.transParam.source.text },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.transParam.source,
                        "text",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "textarea_counter" }, [
                  _vm._v(_vm._s(_vm.getTextLength) + " / 5000")
                ])
              ]),
              _vm._v(" "),
              _c("dd", { attrs: { "data-input-type": "textarea" } }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.transParam.target.text,
                      expression: "transParam.target.text"
                    }
                  ],
                  staticClass: "textarea_ty w100p",
                  attrs: { id: "targetText", rows: "15", placeholder: "" },
                  domProps: { value: _vm.transParam.target.text },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.transParam.target,
                        "text",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _vm._m(1)
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("em", { staticClass: "ico_translate" }, [
      _c("span", { staticClass: "sr_only" }, [_vm._v("ico_translate")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tooltip_wrap fl_right" }, [
      _c("small", { staticClass: "text-muted" }, [
        _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")]),
        _vm._v("\n                            Powered by UTrans ("),
        _c(
          "a",
          { attrs: { href: "mailto:utrans@samsung.com", target: "_top" } },
          [_vm._v("utrans@samsung.com")]
        ),
        _vm._v(")\n                        ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71c34621", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c34621","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/common/popup/TransPopup.vue
// module id = i0Nj
// module chunks = 0